import { Component, EventEmitter, Output, computed, inject, signal } from '@angular/core';

import { Accessible } from '../../../../shared/mixins/accessible.mixin';
import {
    LiquidViewerService
} from 'src/index/services.index';
import {
    LiquidViewerPositions,
} from '../../../liquid-viewer.models';
import {
    LiquidPageDimensions,
    LiquidPageOrientations,

} from '../../../liquid-page/liquid-page.models';

@Component({
    selector: 'meta-liquid-settings',
    templateUrl: './liquid-settings.component.html',
    styleUrls: ['./liquid-settings.component.css'],
})
export class LiquidSettingsComponent extends Accessible {
    liquidViewerService = inject(LiquidViewerService);

    @Output() doClose = new EventEmitter();

    override verticalNavSelector = 'button, input[type="radio"]:checked';
    override horizontalNavSelector = 'input[type="radio"]';

    $currentPosition = computed(() => this.liquidViewerService.$toolbarConfig().position);
    $currentFloating = computed(() => this.liquidViewerService.$toolbarConfig().floating);
    $currentProgressBar = computed(() => this.liquidViewerService.$viewerConfig().showProgressBar);
    $currentOrientation = computed(() => this.liquidViewerService.$pageSettings().orientation);
    $currentMargins = computed(() => this.liquidViewerService.$pageSettings().margins);

    /* ---- Toolbar ----- */
    onChangePosition(position: LiquidViewerPositions) {
        this.liquidViewerService.$toolbarConfig.update(cv => ({
            ...cv,
            position: position,
        }));
        this.onClose();
    }

    onChangeFloating(floating: boolean) {
        this.liquidViewerService.$toolbarConfig.update(cv => ({
            ...cv,
            floating: floating,
        }));
        this.onClose();
    }

    /* ---- Page ----- */
    onChangeOrientation(orientation: LiquidPageOrientations) {
        this.liquidViewerService.$pageSettings.update(cv => ({
            ...cv,
            orientation: orientation,
        }));
    }

    onChangeMargins(margins: LiquidPageDimensions) {
        this.liquidViewerService.$pageSettings.update(cv => ({
            ...cv,
            margins: margins,
        }));
    }

    /* ---- Progress bar ----- */
    onChangeProgressBar(showProgressBar: boolean) {
        this.liquidViewerService.$viewerConfig.update(cv => ({
            ...cv,
            showProgressBar: showProgressBar,
        }));
    }

    onClose(): void {
        this.doClose.emit();
    }
}
